import "./hero.css";
import { Reveal } from "../utils/Reveal";
import Lottie from "lottie-react";
import animationData from "../Assets/phone_animation.json";
import { Link } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";

type HeroProps = {
  image: any;
  logo: any;
  heading: string;
  paragraph: string;
  cta: string;
  cta2: string;
};

const Hero = (props: HeroProps) => {
  const { user } = UserAuth();

  return (
    <div className="hero" id="hero" role="banner">
      <div className="hero__container">
        <div className="hero__container__image">
          <Lottie
            animationData={animationData}
            className="hero__container__qr"
            aria-label="Animated QR code demonstration"
          />
        </div>
        <div className="hero__container__details">
          <Reveal>
            <img
              src={props.logo}
              alt="QRSharp logo"
              className="hero__container__logo"
            />
          </Reveal>
          <Reveal>
            <h2>{props.heading}</h2>
          </Reveal>
          <Reveal>
            <p>{props.paragraph}</p>
          </Reveal>
          <div className="hero__container__details__cta">
            {user ? (
              <Link to="/dashboard">
                <button className="btn btn-cta" aria-label="Go to dashboard">
                  Dashboard
                </button>
              </Link>
            ) : (
              <>
                <Link to="/dashboard">
                  <button
                    className="btn btn-cta"
                    aria-label="Sign in to QRSharp"
                  >
                    Sign In
                  </button>
                </Link>
                <Link to="/signup">
                  <button
                    className="btn btn-register"
                    aria-label="Register for QRSharp"
                  >
                    {props.cta2}
                  </button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
